import { NgModule } from '@angular/core';
import { MainAssignComponent} from "./components/main-assign.component";
import { SearchServicesComponent} from "./components/dummy/search-services.component";
import { ListAssignServicesComponent} from "./components/dummy/list-assign-services.component";
import { CommonModule } from '@angular/common';
import { AssignRoutes } from './assign.routes';
import { JsonpModule, HttpModule } from '@angular/http';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ServicesService } from "../../injections/services.service";
import { ServiceService } from "../../injections/service.service";
import { UsersService } from "../../injections/users.service";
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {SharedModule} from "../../common/shared.module";



@NgModule({
    imports: [CommonModule,
    AssignRoutes,
    JsonpModule,
    FormsModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    SharedModule,
    HttpModule],
    exports: [],
    declarations: [MainAssignComponent,SearchServicesComponent, ListAssignServicesComponent],
    providers: [ServicesService, ServiceService, UsersService],
})

export class AssignModule { }



// WEBPACK FOOTER //
// ./src/app/modules/assign/assign.module.ts